import React, { PropTypes, Component } from 'react';

import Container from '../components/layouts/Container';
import Page from '../components/layouts/Page';

class MainLayoutWide extends Component {
  render() {
    return (
      <Container wide>
        <Page header>{this.props.children}</Page>
      </Container>
    );
  }
}

MainLayoutWide.propTypes = {
  children: PropTypes.object
};

export default MainLayoutWide;



// WEBPACK FOOTER //
// ./src/layouts/MainLayoutWide.js